import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../src/assets/i18n/en.json';
import translationDE from '../src/assets/i18n/de.json';
import platformLanguages from './data/platformLanguage';

const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    load: 'languageOnly',
    saveMissingPlurals: false,
    supportedLngs: platformLanguages.languageArray,
    fallbackLng: 'en',
    debug: false,
    useSuspense: true,
    resources,
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    initImmediate: false,
    ready: true
  });

export default i18n;
